import { render, staticRenderFns } from "./company.vue?vue&type=template&id=7ce7c424&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=7ce7c424&lang=css"
import style1 from "./company.vue?vue&type=style&index=1&id=7ce7c424&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce7c424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce7c424')) {
      api.createRecord('7ce7c424', component.options)
    } else {
      api.reload('7ce7c424', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=7ce7c424&scoped=true", function () {
      api.rerender('7ce7c424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/organizationChild/company.vue"
export default component.exports